import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/services/shared.service';

@Injectable({
  providedIn: 'root'
  
})
export class FaqService {
  faqItems: any[] = [];
  loading: boolean


  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) {}

  getAllFAQs(): Observable<any> {
    const test = this.http.get(`${this.sharedService.apiUrl}/faqs`)
    return this.http.get(`${this.sharedService.apiUrl}/faqs`);
  }

  searchFAQs(searchTerm: string): Observable<any> {
    return this.http.get(`${this.sharedService.apiUrl}/faqs/search/${searchTerm}`);
  }

  addFAQCategory(categoryData: any): Observable<any> {
    return this.http.post(`${this.sharedService.apiUrl}/faqs`, categoryData);
  }

  addQuestion(categoryId: string, questionData: any): Observable<any> {
    return this.http.post(`${this.sharedService.apiUrl}/faqs/${categoryId}/question`, questionData);
  }

  updateQuestion(categoryId: string, questionId: string, questionData: any): Observable<any> {
    return this.http.put(`${this.sharedService.apiUrl}/faqs/${categoryId}/question/${questionId}`, questionData);
  }
  loadFAQs() {
    this.loading = true;
    this.http.get(`${this.sharedService.apiUrl}/faqs`).subscribe({
      next: (response) => {
        console.warn('FAQ Response:', response); // Log the actual response here
        console.warn('FAQ Data:', response['data']); // Log just the data
        this.faqItems = response['data'];
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading FAQs:', error);
        this.loading = false;
      },
    });
  }
}